import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { EnvironmentService } from '@app/environments/services/environment.service';
import { X_IBM_CLIENT_ID } from '../../auth/auth.constants';

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {

  constructor(
    private readonly environmentService: EnvironmentService,
  ) {}

  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (this.environmentService.environment.apicEnabled) {
      const clonedRequest = httpRequest.clone({
        withCredentials: true,
        setParams: {
          [X_IBM_CLIENT_ID]: this.environmentService.environment.apiGateway.postData.x_ibm_client_id
        }
      });

      return next.handle(clonedRequest);
    }

    return next.handle(httpRequest);
  }

}
